// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiGithub as RawSiGithub } from "react-icons/si";
export const SiGithub = /* @__PURE__ */ createIcon(RawSiGithub, "SiGithub", 0);
